window.Varellea.register('site-footer', root => {
  const controller = new AbortController();
  const signal = controller.signal;
  const disclosures = [...root.querySelectorAll('[data-footer-disclosure]')];
  const mobile = window.matchMedia('(max-width: 749px)');
  let initialized = false;

  function sync() {
    const collapsible = mobile.matches && root.dataset.mobileAccordion === 'true';
    for (const disclosure of disclosures) {
      disclosure.open = !collapsible;
      disclosure.querySelector('summary').tabIndex = collapsible ? 0 : -1;
    }
    initialized = true;
  }

  return {
    connect() {
      sync();
      mobile.addEventListener('change', sync, { signal });
      root.addEventListener('click', event => {
        const summary = event.target.closest('[data-footer-disclosure] > summary');
        if (!summary) return;
        if (!mobile.matches || root.dataset.mobileAccordion !== 'true') event.preventDefault();
      }, { signal });
      root.addEventListener('varellea:block:select', event => {
        const disclosure = event.target.closest('.varellea-footer__block')?.querySelector('[data-footer-disclosure]');
        if (disclosure) disclosure.open = true;
      }, { signal });
    },
    disconnect() {
      controller.abort();
      if (initialized) disclosures.forEach(disclosure => { disclosure.open = true; });
    }
  };
});
